// import { X } from 'lucide-react';
import cash from '@/assets/cash.svg';
import trophy from '@/assets/funnel-trophy.svg'
import { Button } from '../ui/button';
import { useModal } from '@/hooks/useModal';
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import arrowLottie from "@/assets/lottie/arrow.lottie?url";
import { gameThemes } from '@/themes/themes';
import dollarsign from "@/assets/dollarsign.svg";
import { type Price, PurchaseModal } from './PurchaseModal';
import type { GameThemeId } from '@skillscratch/shared-types';
import { getStoreById, type StoreListing } from '@/helpers/storeListings';


// function CloseButton() {
//     const { closeModal } = useModal();

//     return (
//         // biome-ignore lint/a11y/useButtonType: <explanation>
//         <button className="bg-blue-sky opacity-50 text-gray-400 hover:text-gray-600 p-2 rounded-tl-xl rounded-br-xl top-0 left-0 absolute z-50"
//         onClick={() => {
//             console.log('Close button clicked');
//             closeModal()
//         }}>
//             <X size={28} />
//         </button>
//     );
// }

function Header() {
  return (
    <div className="flex flex-col items-center mb-4 pt-6">
        <div className="text-white">
          <img
            src={cash}
            className='h-16'
            alt='book'
          />
        </div>
      <h2 className="text-3xl font-semibold text-blue-dark mt-4">Ready to win?</h2>
    </div>
  );
}

interface InfoSectionProps {
    // Accept any React node as the icon
    icon: React.ReactNode;
    title: string;
    subtitle: string;
    // Optional className for styling the wrapper
    className?: string;
}
  
  function InfoSection({
    icon,
    title,
    subtitle,
    className,
  }: InfoSectionProps) {
    return (
      <div className={className}>
        {/* Just render whatever icon element is passed in */}
        {icon}
        
        <div>
          <div className="-translate-y-1">
            <h3 className="text-lg font-semibold text-blue-dark">{title}</h3>
            <p className="text-blue-dark text-md text-left">{subtitle}</p>
          </div>
        </div>
      </div>
    );
  }
  
  // Example custom icon components
  function TreasureIcon() {
    const { card } = gameThemes['crazy-99s'];
    
    return (
      <div className='flex flex-col gap-1 w-1/2 mr-0 items-center'>
        <img src={card} className="rounded-lg" alt="crazy-99s" />
        <p className='font-bold text-purple-500 text-sm'>$99,000</p>
      </div>
    );
  }
  
  function CluesIcon() {
    return (
      <div className='flex flex-col gap-2 w-1/2 mr-0 justify-center items-center h-full bg-blue-sky py-3 rounded-lg'>
        <img src={trophy} className="w-9" alt="Clues" />
      </div>
    );
  }
  
  
  // Now using the separate icon components
  function HowToWinSection() {
    return (
      <InfoSection
        icon={<TreasureIcon />}
        title="Try Crazy99s first!"
        subtitle="TX’s smallest card, just $10. Win up to $99K."
        className={"mt-4 flex items-start gap-4 px-5"}
      />
    );
  }
  
  function SolveWithCluesSection() {
    return (
      <InfoSection
        icon={<CluesIcon />}
        title="Scratch with $5 off"
        subtitle="It’s a $10 card, so with your credit it’s just $5!"
        className={"mt-4 flex items-center gap-4 px-5"}
      />
    );
  }
  
//   function GoFastSection() {
//     return (
//       <InfoSection
//         icon={<CustomDollarIcon />}
//         title="Go fast to win big"
//         subtitle="To win the largest prizes, find 10 treasures fastest"
//       />
//     );
//   }

// Start Button Component
function StartButton() {
  const { openModal } = useModal();

  const openPurchaseModal = () => { 
    const id = gameThemes['crazy-99s'].id;
    const listing = getStoreById(id as GameThemeId) as StoreListing;
    openModal(<PurchaseModal id={id} prices={listing?.prices as Price[]} priceId={listing?.prices[0].id} key={id} />);
  }

  return (
    <div className="mt-2 p-4 flex justify-center">
        <Button 
          className="py-6 bg-blue text-white text-2xl font-bold w-full rounded-lg flex items-center justify-center gap-3"
          shine
          onClick={() => openPurchaseModal()}
        >
            <span className='items-center justify-center'>Scratch for $5 <span className="line-through">$10</span></span>
            <span className='h-5 w-5 items-center justify-center'>
              <DotLottieReact
                src={arrowLottie}
                autoplay
                loop
                style={{
                  objectFit: "contain",
                }}
              />
            </span>
        </Button>
    </div>
  );
}

// Main TutorialModal Component
export function GuidedPurchaseModal() {
  return (
    <div className="bg-white rounded-xl min-w-md mx-4 w-80 relative">
      <div>
        <div className="relative">
          <Header />
        </div>
        <div className="mt-8">
            <HowToWinSection />
            <SolveWithCluesSection />
            {/* <GoFastSection /> */}
        </div>
      </div>
      <StartButton />
      <AnimatedWinUpToTag />
    </div>
  );
}

function AnimatedWinUpToTag() {
    return (
        <div className='h-20'>
          {(() => {
            switch ('loaded') {
              case 'loaded':
                return (
                  <div 
                    className='
                      absolute bg-emerald-50 text-white p-3 bottom-0 
                      flex justify-center items-center border-t border-emerald-200 
                      rounded-bl-lg rounded-br-lg w-full
                    '
                  >
                    <h1 className="text-xl font-bold text-emerald-400 flex items-center justify-center gap-1.5">
                      <img src={dollarsign} alt='dollarsign' className='h-7'/>
                      Wins up to $99,000
                    </h1>
                  </div>
                );
              default:
                return null;
            }
          })()}
        </div>
      );
}